import { useSyncExternalStore } from 'react';

/* Impersonação AUDITADA (concessão do servidor: motivo + TTL + trilho).
   sessionStorage de propósito: uma sessão de suporte não sobrevive ao fecho do
   separador. Só guardamos o ID da concessão — quem manda é o servidor: expirada
   ou revogada, o header deixa de ter efeito. */
const KEY = 'hq.impersonation';

export interface Grant { grantId: string; targetUserId: string; targetName: string; expiresAt: string }

let listeners: Array<() => void> = [];
const emit = () => listeners.forEach((l) => l());

function read(): Grant | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const g = JSON.parse(raw) as Grant;
    return g?.grantId ? g : null;
  } catch { return null; }
}

let cache: Grant | null = read();

export function setGrant(g: Grant | null) {
  try { g ? sessionStorage.setItem(KEY, JSON.stringify(g)) : sessionStorage.removeItem(KEY); } catch { /* modo privado */ }
  cache = g;
  emit();
}

export function currentGrantId(): string | null { return cache?.grantId ?? null; }

export function useGrant(): Grant | null {
  return useSyncExternalStore(
    (cb) => { listeners.push(cb); return () => { listeners = listeners.filter((l) => l !== cb); }; },
    () => cache,
  );
}
